import { render, staticRenderFns } from "./InboundSettings.vue?vue&type=template&id=420be12c&scoped=true&"
import script from "./InboundSettings.vue?vue&type=script&lang=js&"
export * from "./InboundSettings.vue?vue&type=script&lang=js&"
import style0 from "./InboundSettings.vue?vue&type=style&index=0&id=420be12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420be12c",
  null
  
)

/* custom blocks */
import block0 from "./InboundSettings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports